export const REPORT_TYPE = {
  total_users: {
    id: 'total_users',
    name: '總用戶數',
  },
  total_purchase_urls: {
    id: 'total_purchase_urls',
    name: '購買連結生成數'
  },
  total_user_questions: {
    id: 'total_user_questions',
    name: '用戶提問數'
  },
  hourly_user_questions: {
    id: 'hourly_user_questions',
    name: '平均提問數/hr'
  },
  day_questions: {
    id: 'day_questions',
    name: '今日/昨日比較(提問數)'
  },
  month_questions: {
    id: 'month_questions',
    name: '本月/上月比較(提問數)'
  },
  question_product_types: {
    id: 'question_product_types',
    name: '用戶提問類別占比'
  },
  engaged_button_types: {
    id: 'engaged_button_types',
    name: '互動按鈕占比'
  },
  popular_question_products: {
    id: 'popular_question_products',
    name: '用戶熱門提問商品',
    type: 'line'
  },
  generated_pruchase_urls: {
    id: 'generated_pruchase_urls',
    name: '期間購買連結生成趨勢分析',
    type: 'line'
  },
  user_questions: {
    id: 'user_questions',
    name: '期間用戶提問趨勢分析',
    type: 'line'
  }
}